
import http from "./http";

export const fetchDashboardData = () => http.get("/users/dashboard");
export const updateNextOfKin = (userId, payload) => { return http.post(`/users/nextofkin/${userId}/add`, payload) }
export const updateUserProfile = (payload) => { return http.put("/users/details/edit", payload) }
export const showNextOfKin = (userId) => { return http.get(`/users/nextofkin/${userId}/show`) }
export const fetchBanks = () => http.get("/users/onboard/banks");
export const fetchCountries = () => http.get("/users/onboard/countries");
